import { Component } from '@angular/core';

@Component({
  selector: 'app-tds-solution',
  standalone: true,
  imports: [],
  templateUrl: './tds-solution.component.html',
  styleUrl: './tds-solution.component.scss'
})
export class TdsSolutionComponent {

}
